import { app } from '../../../core/App';
import { Sounds } from '../../../sounds';
import CharacterSpine, { CharacterAnimation } from '../CharacterSpine';
import { EquipmentType } from '../VehicleEquipment';
import { VehicleEquipmentProjectileWeapon } from '../VehicleEquipmentProjectileWeapon';
import { VehicleVillain } from '../VehicleVillain';
import { ObstacleInk } from '../../level/entities/obstacle/ObstacleInk';
import { SpineEvents } from '../../../core/enums/SpineEvents';

export class VehicleWeaponInk extends VehicleEquipmentProjectileWeapon {
  constructor(scene: Phaser.Scene, vehicle: VehicleVillain, camera: Phaser.Cameras.Scene2D.Camera, spine: CharacterSpine) {
    super(scene, EquipmentType.Ink, vehicle, camera, spine, ObstacleInk);

    this.spine.on(SpineEvents.End, this.animationEnd, this);
    this.scene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.cleanUp, this);
  }

  public fire(): void {
    this.vehicle.CharacterSpine.fireEquipment();
    this.emit(VehicleWeaponInk.events.Firing);

    this.scene.time.delayedCall(500, () => {
      let ink = new ObstacleInk(this.scene, this.vehicle.x - 30, this.vehicle.y - 20);
      this.vehicle.VehicleDetails.vehicleLayer.add(ink as unknown as Phaser.GameObjects.GameObject);
      ink.onFire();
    });
  }

  public onFinishedFiring() {
    this.emit(VehicleWeaponInk.events.FinishedFiring);
  }

  protected override animationEnd(entry: spine.TrackEntry) {
    if (entry.animation.name == CharacterAnimation.Weapon) {
      this.onFinishedFiring();
    }
  }

  protected cleanUp() {
    this.spine.off(SpineEvents.End, this.animationEnd, this);
  }
}
